var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPaymentMade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M9.364 17.95a1.432 1.432 0 0 1-1.38-1.057c-.006-.022-.006-.043-.01-.065l-3.935-2.126a.7.7 0 0 0-.487-.08.702.702 0 0 0-.581.698.71.71 0 0 0 .355.62l6.511 3.896c.171.107.368.164.57.164h5.031c.135 0 .268-.026.394-.075l1.31-.518V15.56l-1.276-.765a1.07 1.07 0 0 0-.55-.152h-1.37c-.217 0-.434.028-.645.085L9.18 15.83a.722.722 0 0 0-.527.63v.116a.714.714 0 0 0 .712.658c.044-.003.254-.046.417-.083l3.698-.99.184.69-3.71.993c-.193.052-.39.087-.589.105z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M17.857 14.286H20V20h-2.143z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M0 0h2.143v6.429H0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M4.076 5.62a3.22 3.22 0 0 0 1.638.534V4.428a2.597 2.597 0 0 1-.73-.41l-.21-.17.45-.554.208.168c.708.565 1.717.55 2.407-.036l.25-.214 2.107 2.107a.716.716 0 0 0 1.011-1.015l-2.52-2.523.505-.505.867.867h2.947L11.595.732A2.483 2.483 0 0 0 9.827 0h-4.49c-.166 0-.33.039-.479.113l-.8.4a1.793 1.793 0 0 1-.864.188L2.857.689v4.668h.821z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M6.428 4.578v6.136H20V2.857h-9.227l.714.714H17.5v.358c0 .788.64 1.428 1.429 1.428h.357v2.857h-.358c-.788 0-1.428.64-1.428 1.429V10H8.928v-.357c0-.79-.64-1.429-1.428-1.429h-.357V5.357H7.5c.453 0 .878-.216 1.147-.58l-.61-.61a2.598 2.598 0 0 1-1.609.411z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M10.704 6.239c-.378 0-.74-.148-1.01-.414l-.538-.54c-.327.402-.789.67-1.299.757V7.53a2.149 2.149 0 0 1 1.756 1.756h7.202a2.149 2.149 0 0 1 1.756-1.756V6.042a2.149 2.149 0 0 1-1.756-1.756h-4.782c.17.42.127.899-.117 1.282a1.786 1.786 0 1 1-.203.259 1.438 1.438 0 0 1-1.009.412z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M14.286 6.786a1.072 1.072 0 1 1-2.143 0 1.072 1.072 0 0 1 2.143 0z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMade);
export default __webpack_public_path__ + "static/media/icon-payment-made.e9da959f.svg";
export { ForwardRef as ReactComponent };